import { Injectable, computed, signal } from "@angular/core";
import { PhmsReturnContext, readReturnContext } from "./phms-detail-navigation";

export interface PhmsDetailNavBarConfig {
  pageLabel?: string;
  contextLabel?: string;
  fallbackUrl?: string;
  fallbackLabel?: string;
  showFallback?: boolean;
}

interface PhmsDetailNavBarState {
  enabled: boolean;
  pageLabel: string;
  contextLabel: string;
  fallbackUrl: string;
  fallbackLabel: string;
  showFallback: boolean;
  returnContext: PhmsReturnContext | null;
}

const DEFAULT_STATE: PhmsDetailNavBarState = {
  enabled: false,
  pageLabel: "",
  contextLabel: "",
  fallbackUrl: "/phms/dashboard",
  fallbackLabel: "Dashboard",
  showFallback: true,
  returnContext: null,
};

@Injectable({ providedIn: "root" })
export class PhmsDetailNavBarService {
  private readonly stateSignal = signal<PhmsDetailNavBarState>({ ...DEFAULT_STATE });

  readonly state = computed(() => this.stateSignal());

  show(config: PhmsDetailNavBarConfig = {}): void {
    this.stateSignal.set({
      ...DEFAULT_STATE,
      ...config,
      enabled: true,
      returnContext: readReturnContext(readHistoryState()),
    });
  }

  clear(): void {
    this.stateSignal.set({ ...DEFAULT_STATE });
  }
}

function readHistoryState(): unknown {
  return typeof history !== "undefined" ? history.state : null;
}
